import { isRequiresRelation } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import { selectApiWithPendingChangesRelationsToAndFromMap } from '@newStore/documentApi/documentApiSelectors';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import type { EditAsideDevelopmentPhase } from '@nodeTypeConfig/configTypes';
import {
  addRelationAction,
  patchRelationAction,
  removeRelationAction,
} from '@store/actions/documentActions';
import { any } from 'prop-types';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { selectDevelopmentPhaseOptions } from './asideDevelopmentPhaseSelectors';

const AsideDevelopmentPhase: React.FC<{
  config: EditAsideDevelopmentPhase;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  useEffect(() => {
    dispatch(
      loadReferenceFrame({
        referenceFrame: referenceFrames.ontwikkelingsfasesAN,
      }),
    );
  }, [dispatch]);

  const anValues = useSelector((state: RootState) => selectDevelopmentPhaseOptions(state));

  const relation = useSelector((state: RootState) =>
    selectApiWithPendingChangesRelationsToAndFromMap(state).from[editHref]?.find(
      isRequiresRelation,
    ),
  );

  const initialValue = relation && anValues.find((v) => v.href === relation.to.href);

  const onChange = (selection) => {
    if (!selection) {
      if (relation) {
        dispatch(removeRelationAction(relation.key));
      }
    } else if (relation) {
      dispatch(
        patchRelationAction(relation.key, {
          to: { href: selection.href },
        }),
      );
    } else {
      const newRelation = {
        relationtype: 'REQUIRES',
        strength: 'MEDIUM',
        from: {
          href: editHref,
        },
        to: {
          href: selection.href,
        },
      };
      dispatch(addRelationAction(newRelation));
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {config.label && (
          <label className="control-label control-label-inline">{config.label}</label>
        )}
      </div>
      <div className="col-md-12">
        <KovResourcePicker
          localData={anValues}
          display="name"
          value={initialValue}
          clearable={true}
          disabled={readonly}
          disableSearch={true}
          onChange={onChange}
          optionValue={(o) => o.href}
          style={{
            menu: (provided) => ({ ...provided, zIndex: 3 }),
            option: (provided) => ({ ...provided, cursor: 'pointer' }),
          }}
        />
      </div>
    </div>
  );
};

AsideDevelopmentPhase.displayName = 'AsideDevelopmentPhase';

export default AsideDevelopmentPhase;

AsideDevelopmentPhase.propTypes = {
  config: any,
  readonly: any,
};
